import React, {Fragment, PureComponent} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getFavourites} from '../../actions/favourite.action';
import Product from '../../components/Product/Product';
import Loading from '../../components/Loading/Loading';
import {
  NoItemsAvailable,
  NoFavouritesText,
  FavIconWrapper,
  FavoritedIcon,
} from './FavouritesPage.style';
import {syncBasketQuantityWithProducts} from '../../helpers/product.helper';
import {getFilterPillItems} from '../../helpers/data.helper';
import {
  ANALYTICS_SOURCES,
  FAVOURITES_PARAMS,
  ROUTES,
  SCROLL_THRESHOLD,
  SEARCH_SORT_OPTIONS,
  SEARCH_SORT_TYPE,
  getInitialPageSize,
} from '../../constants/constants';
import InfiniteScroll from 'react-infinite-scroll-component';
import {setCurrentRoute} from '../../actions';
import ToTheTop from '../../components/ToTheTop/ToTheTop';
import {setPrevRoute} from '../../actions/prevRoute.action';
import {toggleNewOfferModal} from '../../actions/modal.action';
import {
  BreadCrumb,
  BreadCrumbLinks,
  ClearFilter,
  Container,
  CurrentPage,
  DoneButton,
  FilterButton,
  FilterButtonWrapper,
  FilterInfo,
  FilterOverlayBackdrop,
  FilterPill,
  FilterPillsWrapper,
  FiltersButtons,
  FiltersScrollArea,
  FiltersWrapper,
  NameWrapper,
  ProductCount,
  ResultsPanel,
  ResultsTitle,
  ResultsWrapper,
  Separator,
  SortButton,
  SortDropdownItem,
  SortDropdownPanel,
  SortWrapper,
  Status,
  ToolBar,
} from '../SearchPage/SearchPage.style';
import Filters from '../../components/Filters/Filters';
import {LeftLine, RightLine} from '../../styles/components/lines';

class FavouritesPage extends PureComponent {
  state = {
    params: {...FAVOURITES_PARAMS, size: getInitialPageSize()},
    showFilterInMobile: false,
    showSortDropdown: false,
    sortType: null,
  };

  sortWrapperRef = React.createRef();
  filtersScrollRef = React.createRef();
  _savedScrollY = 0;

  lockBodyScroll = () => {
    this._savedScrollY = window.scrollY;
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${this._savedScrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
  };

  unlockBodyScroll = () => {
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    window.scrollTo(0, this._savedScrollY);
  };

  toggleFilterInMobile = () =>
    this.setState(
      prev => ({showFilterInMobile: !prev.showFilterInMobile}),
      () => {
        if (this.state.showFilterInMobile) {
          this.lockBodyScroll();
          if (this.filtersScrollRef.current) {
            this.filtersScrollRef.current.scrollTop = 0;
          }
        } else {
          this.unlockBodyScroll();
        }
      }
    );

  closeFilterInMobile = () => {
    this.setState({showFilterInMobile: false});
    this.unlockBodyScroll();
  };

  applyFilters = () => {
    this.closeFilterInMobile();
  };

  updateSearchParams = updatedParams => {
    const params = {...this.state.params, ...updatedParams};
    this.setState({params});
    this.props.getFavourites(0, params);
  };

  clearFilters = () => {
    const {
      sizeOrCut,
      origin,
      brand,
      productFeatures,
      category,
      ...baseParams
    } = this.state.params;
    this.setState({params: baseParams});
    this.props.getFavourites(0, baseParams);
    window.scrollTo(0, 150);
  };

  componentDidMount() {
    document.addEventListener('mousedown', this.handleSortOutsideClick);
    const {
      getFavourites,
      setCurrentRoute,
      prevRoute,
      history,
      modal,
      toggleNewOfferModal,
    } = this.props;
    if (prevRoute === null && modal.newOffers === undefined) {
      toggleNewOfferModal(true);
    }
    const isNewSearch =
      history.location &&
      history.location.state &&
      history.location.state.newSearch;
    setCurrentRoute(ROUTES.FAVOURITES);
    if (prevRoute === ROUTES.PRODUCT && !isNewSearch) {
      return;
    }
    getFavourites(this.state.params.page, this.state.params);
  }

  componentDidUpdate(prevProps) {
    const {auth, getFavourites} = this.props;
    if (auth && auth !== prevProps.auth) {
      getFavourites(this.state.params.page, this.state.params);
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleSortOutsideClick);
  }

  handleSortOutsideClick = e => {
    if (
      this.sortWrapperRef.current &&
      !this.sortWrapperRef.current.contains(e.target)
    ) {
      this.setState({showSortDropdown: false});
    }
  };

  toggleSortDropdown = () =>
    this.setState(prev => ({showSortDropdown: !prev.showSortDropdown}));

  selectSort = value => {
    const {getFavourites} = this.props;
    const params = {...this.state.params, sortType: value};
    this.setState({sortType: value, params, showSortDropdown: false});
    getFavourites(0, params);
  };

  loadMore = () => {
    const {getFavourites, favourites} = this.props;
    const {params} = this.state;
    getFavourites(favourites.page.number + 1, params);
  };

  render() {
    const {
      basket,
      favourites,
      loading,
      branch,
      updateBasket,
      updateItem,
      removeItem,
      basketHashMap,
      deviceInfo,
      auth,
      onProductClick,
      keywordSearch,
      setPrevRoute,
      aggression,
    } = this.props;
    const {showSortDropdown, showFilterInMobile, params} = this.state;
    const navToProduct = itemId => {
      setPrevRoute(ROUTES.FAVOURITES);
      onProductClick(itemId);
    };
    const favouritedItems =
      (favourites && favourites._embedded && favourites._embedded.products) ||
      [];
    const favouriteItems = syncBasketQuantityWithProducts(
      basketHashMap,
      favouritedItems
    );
    const notLoginText =
      !auth &&
      loading &&
      !loading.gettingProducts &&
      'Log in to select and view favourites';
    const noFavouritesText = auth && loading && !loading.gettingProducts && (
      <NoFavouritesText>
        To add products to your Favourites list just click on the heart symbol
        <FavIconWrapper>
          <FavoritedIcon />
        </FavIconWrapper>
        on any products
      </NoFavouritesText>
    );
    const hasMore =
      favourites &&
      favourites.page &&
      favourites.page.number < favourites.page.totalPages - 1;

    const renderLoading = loading.gettingProducts &&
      favouriteItems.length === 0 && <Loading isLight={false} />;

    const renderGoTop = favourites &&
      favourites.page &&
      favourites.page.number > 0 && <ToTheTop />;

    const renderNoItems =
      favouriteItems.length === 0 ? (
        <NoItemsAvailable>
          {notLoginText}
          {noFavouritesText}
        </NoItemsAvailable>
      ) : null;

    const renderContent = (
      <InfiniteScroll
        next={this.loadMore}
        hasMore={hasMore}
        dataLength={favouriteItems.length}
        scrollThreshold={SCROLL_THRESHOLD}
        loader={<Loading isLight={false} />}
      >
        {favouriteItems.map((product, index) => (
          <Product
            product={product}
            branch={branch}
            key={product.itemId + index}
            searchId={product._searchId}
            searchPosition={index}
            onProductClick={navToProduct}
            loading={loading}
            basketHashMap={basketHashMap}
            updateBasket={updateBasket}
            updateItem={updateItem}
            removeItem={removeItem}
            fulfillmentType={basket && basket.fulfillmentType}
            deviceInfo={deviceInfo}
            source={ANALYTICS_SOURCES.FAVOURITES}
            keywordSearch={keywordSearch}
          />
        ))}
      </InfiniteScroll>
    );

    const activeSortType = this.state.sortType || SEARCH_SORT_TYPE.RELEVANCE;
    const activeSortLabel = (
      SEARCH_SORT_OPTIONS.find(o => o.value === activeSortType) ||
      SEARCH_SORT_OPTIONS[0]
    ).label;

    const appliedFilters = {
      sizeOrCut: !!params.sizeOrCut,
      origin: !!params.origin,
      brand: !!params.brand,
      productFeatures: !!params.productFeatures,
      categoryList: !!params.category,
    };

    const totalElements =
      favourites && favourites.page && favourites.page.totalElements;

    const renderFilterButton = favouriteItems.length > 0 && (
      <FilterButtonWrapper>
        <FilterButton onClick={this.toggleFilterInMobile}>
          {showFilterInMobile ? 'Hide Filters' : 'Show Filters'}
          <Status $selected={showFilterInMobile} />
        </FilterButton>
      </FilterButtonWrapper>
    );

    const renderFilters = aggression && (
      <Filters
        params={params}
        updateSearchParams={this.updateSearchParams}
        filters={aggression}
        appliedFilters={appliedFilters}
        showInMobile={showFilterInMobile}
        isCategorySearch={false}
        isCurrentSearch={true}
        closedByDefault={true}
      />
    );

    const renderFilterTitle = totalElements > 0 && (
      <FilterInfo>
        <span>{`Filter ${totalElements} products by:`}</span>
        <ClearFilter onClick={this.clearFilters}>clear filters</ClearFilter>
      </FilterInfo>
    );

    const filterPillItems = getFilterPillItems(aggression);
    const renderFilterPills = filterPillItems.length > 0 && (
      <FilterPillsWrapper>
        <div>
          {filterPillItems.map(({id, name, unqueryParams}) => (
            <FilterPill
              key={id}
              onClick={() => this.updateSearchParams(unqueryParams)}
            >
              {name}
            </FilterPill>
          ))}
        </div>
      </FilterPillsWrapper>
    );

    const renderFiltersWrapper = favouriteItems.length > 0 && (
      <FiltersWrapper $showInMobile={showFilterInMobile}>
        <FiltersScrollArea ref={this.filtersScrollRef}>
          {renderFilterTitle}
          {renderFilters}
        </FiltersScrollArea>
        <FiltersButtons>
          <DoneButton onClick={this.applyFilters}>Apply Filters</DoneButton>
        </FiltersButtons>
      </FiltersWrapper>
    );

    return (
      <Fragment>
        <BreadCrumb>
          <span>
            <BreadCrumbLinks to="/">Home</BreadCrumbLinks>
            <Separator> › </Separator>
            <CurrentPage $noPadding>My Favourites</CurrentPage>
          </span>
          {totalElements > 0 && (
            <ProductCount>{totalElements} Products found</ProductCount>
          )}
        </BreadCrumb>
        <ToolBar>
          <SortWrapper ref={this.sortWrapperRef}>
            <SortButton onClick={this.toggleSortDropdown}>
              {`Sort: ${activeSortLabel}`}
            </SortButton>
            {showSortDropdown && (
              <SortDropdownPanel>
                {SEARCH_SORT_OPTIONS.map(opt => (
                  <SortDropdownItem
                    key={opt.value}
                    $active={activeSortType === opt.value}
                    onClick={() => this.selectSort(opt.value)}
                  >
                    {opt.label}
                  </SortDropdownItem>
                ))}
              </SortDropdownPanel>
            )}
          </SortWrapper>
          {renderFilterButton}
        </ToolBar>
        <ResultsTitle>
          <LeftLine />
          <NameWrapper>My Favourites</NameWrapper>
          <RightLine />
        </ResultsTitle>
        <Container>
          <FilterOverlayBackdrop
            $show={showFilterInMobile}
            onClick={this.closeFilterInMobile}
          />
          {renderFiltersWrapper}
          <ResultsPanel>
            {renderFilterPills}
            {renderNoItems}
            <ResultsWrapper $gridView={true} $maxColumns={4}>
              {renderContent}
              {renderLoading}
            </ResultsWrapper>
          </ResultsPanel>
          {renderGoTop}
        </Container>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  favourites: state.favourites,
  auth: state.auth,
  loading: state.loading,
  branch: state.branch,
  prevRoute: state.prevRoute,
  modal: state.modal,
  aggression: state.aggression,
});

const mapDispatchToProps = dispatch => ({
  getFavourites: bindActionCreators(getFavourites, dispatch),
  setCurrentRoute: bindActionCreators(setCurrentRoute, dispatch),
  setPrevRoute: bindActionCreators(setPrevRoute, dispatch),
  toggleNewOfferModal: bindActionCreators(toggleNewOfferModal, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(FavouritesPage);
